var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowNext = function SvgArrowNext(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 44.8 44.8"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EFEFEF",
    d: "M15.8 1c10.9-3.6 23.7 2.7 27.6 13.5 2.9 7.6 1.3 16.7-4.2 22.7-5.1 5.8-13.3 8.7-20.9 7.2-8.9-1.5-16.4-9-17.9-18C-1.8 15.7 5.2 4.1 15.8 1m3.6 16.3c1.5 1.6 3.1 3.1 4.6 4.7-1.5 1.6-3 3.1-4.5 4.7.4.4 1.2 1.1 1.6 1.5 2.1-2 4.1-4 6.1-6.1-2-2.1-3.9-4.2-6.1-6.1-.4.2-1.3.9-1.7 1.3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#747474",
    d: "M19.4 17.3c.4-.3 1.3-1 1.7-1.4 2.2 1.9 4.1 4 6.1 6.1-2 2.1-4.1 4.1-6.1 6.1-.4-.4-1.2-1.1-1.6-1.5 1.5-1.6 3-3.2 4.5-4.7-1.5-1.5-3-3.1-4.6-4.6"
  })));
};
export default SvgArrowNext;